export default __webpack_public_path__ + "static/media/edit.e3fdbcbe.svg";